import { normalizeHex } from './landingAccent';

export const STYLING_PARAM = 'styling';
export const ACCENT_PARAM = 'accent';
export const THEME_PARAM = 'theme';

/** True when styling query param is "true" (case-insensitive). */
export function isStylingAllowedParam(value) {
  if (value == null || value === '') return false;
  return String(value).trim().toLowerCase() === 'true';
}

export function parseLandingStylingParams(searchParams) {
  const stylingAllowed = isStylingAllowedParam(searchParams.get(STYLING_PARAM));
  const accentRaw = searchParams.get(ACCENT_PARAM);
  const accent = accentRaw ? normalizeHex(accentRaw) : null;
  const themeRaw = searchParams.get(THEME_PARAM);
  const theme = themeRaw === 'light' || themeRaw === 'dark' ? themeRaw : null;

  return { stylingAllowed, accent, theme };
}

/** Strip leading # for share URLs — accent is stored as bare hex in the query string. */
export function accentToParamValue(hex) {
  const normalized = normalizeHex(hex);
  return normalized ? normalized.slice(1) : null;
}

export function buildLandingStylingShareUrl({
  origin = typeof window !== 'undefined' ? window.location.origin : '',
  pathname = '/home',
  searchParams,
  accent,
  theme,
  variant = 'a',
}) {
  const params = new URLSearchParams(searchParams?.toString?.() || searchParams || '');
  params.set(STYLING_PARAM, 'true');
  params.set('v', params.get('v') || variant);

  const accentValue = accentToParamValue(accent);
  if (accentValue) params.set(ACCENT_PARAM, accentValue);
  else params.delete(ACCENT_PARAM);

  if (theme === 'light' || theme === 'dark') params.set(THEME_PARAM, theme);
  else params.delete(THEME_PARAM);

  const qs = params.toString();
  return `${origin}${pathname}${qs ? `?${qs}` : ''}`;
}
